import { getConfig } from '@cian/config/browser';

let ymapsPromise: Promise<YMaps.IYMaps> | null = null;

export const getYMapsApiPromise = () => {
  const config = getConfig();
  const apiKey = config.getStrict<string>('countryside.YandexApiKey');
  const suggestApiKey = config.get<string>('countryside.YandexSuggestApiKey');

  return new Promise<YMaps.IYMaps>((resolve, reject) => {
    if (window.ymaps) {
      resolve(window.ymaps);

      return;
    }

    const element = document.createElement('script');
    element.src = `https://enterprise.api-maps.yandex.ru/2.1/?apikey=${apiKey}&suggest_apikey=${suggestApiKey}&lang=ru-RU&load=package.system&coordorder=longlat`;
    element.async = true;
    element.defer = true;
    element.onload = () => {
      resolve(window.ymaps);
    };
    element.onerror = () => {
      document.body.removeChild(element);
      reject(new Error('Unable to load Yandex Maps API'));
    };
    document.body.appendChild(element);
  });
};

export function loadYmapsApi(options: YMaps.IReadyOptions): Promise<YMaps.IYMaps> {
  if (!ymapsPromise) {
    ymapsPromise = getYMapsApiPromise();
  }

  return ymapsPromise
    .catch(e => {
      ymapsPromise = null;

      throw e;
    })
    .then(ymaps => ymaps.ready(options));
}
